import RestfulClientCore from './RestfulClientCore';

 class AssetAPIClient extends RestfulClientCore {
  constructor() {
    super('https://strapi.vlginvestimentos.com.br');
  }

  async getMembers(){
    let response;
    try {
      response = await super.get('asset-members');
    } catch (error) {
      throw error;
    }
    return response.members
  }

  async getDocuments(){
    let response;
    try {
      response = await super.get('asset-documents');
    } catch (error) {
      throw error;
    }
    return response.documents_groups
  }
}

export default AssetAPIClient;
